var render = function render(){var _vm=this,_c=_vm._self._c;return (this.show)?_c('span',{staticClass:"unavailable"},[_vm._v(" UNAVAILABLE")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }